import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLanguage === 'en' ? 'ja' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('preferredLanguage', newLang);
  };

  // Compact inline toggle - just shows flag of language to SWITCH TO
  return (
    <button
      onClick={toggleLanguage}
      className={`p-1.5 rounded-md hover:bg-slate-100 transition-colors text-lg leading-none ${className}`}
      title={currentLanguage === 'en' ? '日本語に切り替え' : 'Switch to English'}
      aria-label={currentLanguage === 'en' ? 'Switch to Japanese' : 'Switch to English'}
    >
      {currentLanguage === 'en' ? '🇯🇵' : '🇺🇸'}
    </button>
  );
};

export default LanguageSwitcher;
